module.exports = __webpack_public_path__ + "static/media/player_icons.752ac4c4.png";